// extracted by mini-css-extract-plugin
export default {"inputContainer":"AuthError_inputContainer__+K6O-","input":"AuthError_input__ioGYT","button":"AuthError_button__su0R-","successText":"AuthError_successText__vMJL7"};